import { c as _c } from "react/compiler-runtime";
export default function Mute(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />;
    t2 = <line x1="22" x2="16" y1="9" y2="15" />;
    t3 = <line x1="16" x2="22" y1="9" y2="15" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = <svg aria-label="Icon Mute" className={className} fill="none" height="24" role="img" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">{t1}{t2}{t3}</svg>;
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}